import { mount } from "../model/mount";

const B2BWidget = { mount };

declare global {
    interface Window {
        B2BWidget: typeof B2BWidget;
    }
}

window.B2BWidget = B2BWidget;
